exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line[data-v-20e951fa]{height:62px;line-height:62px}.line .item[data-v-20e951fa],.line[data-v-20e951fa]{display:-webkit-box;display:-ms-flexbox;display:flex}.line .item[data-v-20e951fa]{-webkit-box-flex:1;-ms-flex:1;flex:1}.line .span[data-v-20e951fa]{width:90px;text-align:right;font-size:15px}.ivu-radio-group-item[data-v-20e951fa]{height:62px;line-height:62px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-20e951fa","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationBatch/showknowledge.vue
// module id = PVmm
// module chunks = 0